import {CumulativeBonus, JobBonus} from "../employee.model";
import {JobBonusIdInterface} from "./JobBonusIdInterface";
import {Utils} from "../Utils";
import {CumulativeBonusIdInterface} from "./CumulativeBonusIdInterface";


export class JobBonusAndCumulativeBonusHelper  {

  isBonusDisabled(obj: JobBonusIdInterface, bonusId): boolean {
    switch (bonusId) {
      case obj.bonusId1:
        return true;
      case obj.bonusId2:
        return true;
      case obj.bonusId3:
        return true;
      case obj.bonusId4:
        return true;
      case obj.bonusId5:
        return true;
      case obj.bonusId6:
        return true;
      case obj.bonusId7:
        return true;
      case obj.bonusId8:
        return true;
      case obj.bonusId9:
        return true;
      case obj.bonusId10:
        return true;
      case obj.bonusId11:
        return true;
      case obj.bonusId12:
        return true;
      case obj.bonusId13:
        return true;
      case obj.bonusId14:
        return true;
      case obj.bonusId15:
        return true;
      case obj.bonusId16:
        return true;
      case obj.bonusId17:
        return true;
      case obj.bonusId18:
        return true;
      case obj.bonusId19:
        return true;
      case obj.bonusId20:
        return true;
    }
    return false;
  }


  public resetAllJobBonus(obj: JobBonusIdInterface){

    obj.bonusId1 = -1;
    obj.bonusId2 = -1;
    obj.bonusId3 = -1;
    obj.bonusId4 = -1;
    obj.bonusId5 = -1;
    obj.bonusId6 = -1;
    obj.bonusId7 = -1;
    obj.bonusId8 = -1;
    obj.bonusId9 = -1;
    obj.bonusId10 = -1;
    obj.bonusId11 = -1;
    obj.bonusId12 = -1;
    obj.bonusId13 = -1;
    obj.bonusId14 = -1;
    obj.bonusId15 = -1;
    obj.bonusId16 = -1;
    obj.bonusId17 = -1;
    obj.bonusId18 = -1;
    obj.bonusId19 = -1;
    obj.bonusId20 = -1;

  }

  public addDefaultBonus(obj: JobBonusIdInterface, toAdd: JobBonus): boolean{
    // console.log('Trying Default Bonus: ' + JSON.stringify(toAdd,null,1));
    if (!Utils.isNullOrUndefined(toAdd.isDefault)){
      if (toAdd.isDefault) {
        // console.log('Checking if bonus is already present');

        switch (toAdd.id) {
          case obj.bonusId1:
          case obj.bonusId2:
          case obj.bonusId3:
          case obj.bonusId4:
          case obj.bonusId5:
          case obj.bonusId6:
          case obj.bonusId7:
          case obj.bonusId8:
          case obj.bonusId9:
          case obj.bonusId10:
          case obj.bonusId11:
          case obj.bonusId12:
          case obj.bonusId13:
          case obj.bonusId14:
          case obj.bonusId15:
          case obj.bonusId16:
          case obj.bonusId17:
          case obj.bonusId18:
          case obj.bonusId19:
          case obj.bonusId20:

            // console.log('Default Bonus already present');
            return false;
        }
        return this.addBonus(obj,toAdd);
      }
    }
    return false;
  }


  public retrieveBonus(obj: JobBonusIdInterface):number[]{
    const res = new Array<number>();

    if (!Utils.isNullOrUndefined(obj.bonusId1) && obj.bonusId1 > 0){
      res.push(obj.bonusId1);

    } if (!Utils.isNullOrUndefined(obj.bonusId2) && obj.bonusId2 > 0){
      res.push(obj.bonusId2);

    } if (!Utils.isNullOrUndefined(obj.bonusId3) && obj.bonusId3 > 0){
      res.push(obj.bonusId3);

    } if (!Utils.isNullOrUndefined(obj.bonusId4) && obj.bonusId4 > 0){
      res.push(obj.bonusId4);

    } if (!Utils.isNullOrUndefined(obj.bonusId5) && obj.bonusId5 > 0){
      res.push(obj.bonusId5);

    } if (!Utils.isNullOrUndefined(obj.bonusId6) && obj.bonusId6 > 0){
      res.push(obj.bonusId6);

    } if (!Utils.isNullOrUndefined(obj.bonusId7) && obj.bonusId7 > 0){
      res.push(obj.bonusId7);

    } if (!Utils.isNullOrUndefined(obj.bonusId8) && obj.bonusId8 > 0){
      res.push(obj.bonusId8);

    } if (!Utils.isNullOrUndefined(obj.bonusId9) && obj.bonusId9 > 0){
      res.push(obj.bonusId9);

    } if (!Utils.isNullOrUndefined(obj.bonusId10) && obj.bonusId10 > 0){
      res.push(obj.bonusId10);

    } if (!Utils.isNullOrUndefined(obj.bonusId11) && obj.bonusId11 > 0){
      res.push(obj.bonusId11);

    } if (!Utils.isNullOrUndefined(obj.bonusId12) && obj.bonusId12 > 0){
      res.push(obj.bonusId12);

    } if (!Utils.isNullOrUndefined(obj.bonusId13) && obj.bonusId13 > 0){
      res.push(obj.bonusId13);

    } if (!Utils.isNullOrUndefined(obj.bonusId14) && obj.bonusId14 > 0){
      res.push(obj.bonusId14);

    } if (!Utils.isNullOrUndefined(obj.bonusId15) && obj.bonusId15 > 0){
      res.push(obj.bonusId15);

    } if (!Utils.isNullOrUndefined(obj.bonusId16) && obj.bonusId16 > 0){
      res.push(obj.bonusId16);

    } if (!Utils.isNullOrUndefined(obj.bonusId17) && obj.bonusId17 > 0){
      res.push(obj.bonusId17);

    } if (!Utils.isNullOrUndefined(obj.bonusId18) && obj.bonusId18 > 0){
      res.push(obj.bonusId18);

    } if (!Utils.isNullOrUndefined(obj.bonusId19) && obj.bonusId19 > 0){
      res.push(obj.bonusId19);

    } if (!Utils.isNullOrUndefined(obj.bonusId20) && obj.bonusId20 > 0){
      res.push(obj.bonusId20);

    }
    return res;
  }



  public addBonus(obj: JobBonusIdInterface,toAdd:JobBonus):boolean{


    if (Utils.isNullOrUndefined(obj.bonusId1) || obj.bonusId1<=0){
      obj.bonusId1 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId2) || obj.bonusId2<=0){
      obj.bonusId2 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId3) || obj.bonusId3<=0){
      obj.bonusId3 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId4) || obj.bonusId4<=0){
      obj.bonusId4 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId5) || obj.bonusId5<=0){
      obj.bonusId5 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId6) || obj.bonusId6<=0){
      obj.bonusId6 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId7) || obj.bonusId7<=0){
      obj.bonusId7 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId8) || obj.bonusId8<=0){
      obj.bonusId8 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId9) || obj.bonusId9<=0){
      obj.bonusId9 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId10) || obj.bonusId10<=0){
      obj.bonusId10 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId11) || obj.bonusId11<=0){
      obj.bonusId11 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId12) || obj.bonusId12<=0){
      obj.bonusId12 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId13) || obj.bonusId13<=0){
      obj.bonusId13 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId14) || obj.bonusId14<=0){
      obj.bonusId14 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId15) || obj.bonusId15<=0){
      obj.bonusId15 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId16) || obj.bonusId16<=0){
      obj.bonusId16 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId17) || obj.bonusId17<=0){
      obj.bonusId17 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId18) || obj.bonusId18<=0){
      obj.bonusId18 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId19) || obj.bonusId19<=0){
      obj.bonusId19 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.bonusId20) || obj.bonusId20<=0){
      obj.bonusId20 = toAdd.id;
      return true;
    }
    return false;
  }


  public hasJobBonus(obj: JobBonusIdInterface){
    if (obj.bonusId1>0){
      return true;
    }
    if (obj.bonusId2>0){
      return true;
    }
    if (obj.bonusId3>0){
      return true;
    }
    if (obj.bonusId4>0){
      return true;
    }
    if (obj.bonusId5>0){
      return true;
    }
    if (obj.bonusId6>0){
      return true;
    }
    if (obj.bonusId7>0){
      return true;
    }
    if (obj.bonusId8>0){
      return true;
    }
    if (obj.bonusId9>0){
      return true;
    }
    if (obj.bonusId10>0){
      return true;
    }
    if (obj.bonusId11>0){
      return true;
    }
    if (obj.bonusId12>0){
      return true;
    }
    if (obj.bonusId13>0){
      return true;
    }
    if (obj.bonusId14>0){
      return true;
    }
    if (obj.bonusId15>0){
      return true;
    }
    if (obj.bonusId16>0){
      return true;
    }
    if (obj.bonusId17>0){
      return true;
    }
    if (obj.bonusId18>0){
      return true;
    }
    if (obj.bonusId19>0){
      return true;
    }
    if (obj.bonusId20>0){
      return true;
    }
    return false;
  }

  isCumulativeBonusDisabled(obj:CumulativeBonusIdInterface, bonusId:number): boolean {
    switch (bonusId) {
      case obj.cumulativeBonusId1:
        return true;
      case obj.cumulativeBonusId2:
        return true;
      case obj.cumulativeBonusId3:
        return true;
      case obj.cumulativeBonusId4:
        return true;
      case obj.cumulativeBonusId5:
        return true;
      case obj.cumulativeBonusId6:
        return true;
      case obj.cumulativeBonusId7:
        return true;
      case obj.cumulativeBonusId8:
        return true;
      case obj.cumulativeBonusId9:
        return true;
      case obj.cumulativeBonusId10:
        return true;
      case obj.cumulativeBonusId11:
        return true;
      case obj.cumulativeBonusId12:
        return true;
      case obj.cumulativeBonusId13:
        return true;
      case obj.cumulativeBonusId14:
        return true;
      case obj.cumulativeBonusId15:
        return true;
      case obj.cumulativeBonusId16:
        return true;
      case obj.cumulativeBonusId17:
        return true;
      case obj.cumulativeBonusId18:
        return true;
      case obj.cumulativeBonusId19:
        return true;
      case obj.cumulativeBonusId20:
        return true;
    }
    return false;
  }

  // public resetAllBonus(){
  //   obj.resetAllCumulativeBonus();
  // }

  public resetAllCumulativeBonus(obj:CumulativeBonusIdInterface){
    obj.cumulativeBonusId1 = -1;
    obj.cumulativeBonusId2 = -1;
    obj.cumulativeBonusId3 = -1;
    obj.cumulativeBonusId4 = -1;
    obj.cumulativeBonusId5 = -1;
    obj.cumulativeBonusId6 = -1;
    obj.cumulativeBonusId7 = -1;
    obj.cumulativeBonusId8 = -1;
    obj.cumulativeBonusId9 = -1;
    obj.cumulativeBonusId10 = -1;
    obj.cumulativeBonusId11 = -1;
    obj.cumulativeBonusId12 = -1;
    obj.cumulativeBonusId13 = -1;
    obj.cumulativeBonusId14 = -1;
    obj.cumulativeBonusId15 = -1;
    obj.cumulativeBonusId16 = -1;
    obj.cumulativeBonusId17 = -1;
    obj.cumulativeBonusId18 = -1;
    obj.cumulativeBonusId19 = -1;
    obj.cumulativeBonusId20 = -1;
  }

  public addDefaultCumulativeBonus(obj:CumulativeBonusIdInterface,toAdd: CumulativeBonus): boolean{
    // console.log('Trying Default Bonus: ' + JSON.stringify(toAdd,null,1));
    if (!Utils.isNullOrUndefined(toAdd.isDefault)){
      if (toAdd.isDefault) {
        // console.log('Checking if bonus is already present');

        switch (toAdd.id) {
          case obj.cumulativeBonusId1:
          case obj.cumulativeBonusId2:
          case obj.cumulativeBonusId3:
          case obj.cumulativeBonusId4:
          case obj.cumulativeBonusId5:
          case obj.cumulativeBonusId6:
          case obj.cumulativeBonusId7:
          case obj.cumulativeBonusId8:
          case obj.cumulativeBonusId9:
          case obj.cumulativeBonusId10:
          case obj.cumulativeBonusId11:
          case obj.cumulativeBonusId12:
          case obj.cumulativeBonusId13:
          case obj.cumulativeBonusId14:
          case obj.cumulativeBonusId15:
          case obj.cumulativeBonusId16:
          case obj.cumulativeBonusId17:
          case obj.cumulativeBonusId18:
          case obj.cumulativeBonusId19:
          case obj.cumulativeBonusId20:
            // console.log('Default Bonus already present');
            return false;
        }
        return this.addCumulativeBonus(obj,toAdd);
      }
    }
    return false;
  }

  public retrieveCumulativeBonus(obj: CumulativeBonusIdInterface): number[] {
    const res = new Array<number>();
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId1) && obj.cumulativeBonusId1 > 0) {
      res.push(obj.cumulativeBonusId1);
    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId2) && obj.cumulativeBonusId2 > 0) {
      res.push(obj.cumulativeBonusId2);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId3) && obj.cumulativeBonusId3 > 0) {
      res.push(obj.cumulativeBonusId3);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId4) && obj.cumulativeBonusId4 > 0) {
      res.push(obj.cumulativeBonusId4);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId5) && obj.cumulativeBonusId5 > 0) {
      res.push(obj.cumulativeBonusId5);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId6) && obj.cumulativeBonusId6 > 0) {
      res.push(obj.cumulativeBonusId6);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId7) && obj.cumulativeBonusId7 > 0) {
      res.push(obj.cumulativeBonusId7);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId8) && obj.cumulativeBonusId8 > 0) {
      res.push(obj.cumulativeBonusId8);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId9) && obj.cumulativeBonusId9 > 0) {
      res.push(obj.cumulativeBonusId9);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId10) && obj.cumulativeBonusId10 > 0) {
      res.push(obj.cumulativeBonusId10);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId11) && obj.cumulativeBonusId11 > 0) {
      res.push(obj.cumulativeBonusId11);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId12) && obj.cumulativeBonusId12 > 0) {
      res.push(obj.cumulativeBonusId12);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId13) && obj.cumulativeBonusId13 > 0) {
      res.push(obj.cumulativeBonusId13);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId14) && obj.cumulativeBonusId14 > 0) {
      res.push(obj.cumulativeBonusId14);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId15) && obj.cumulativeBonusId15 > 0) {
      res.push(obj.cumulativeBonusId15);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId16) && obj.cumulativeBonusId16 > 0) {
      res.push(obj.cumulativeBonusId16);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId17) && obj.cumulativeBonusId17 > 0) {
      res.push(obj.cumulativeBonusId17);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId18) && obj.cumulativeBonusId18 > 0) {
      res.push(obj.cumulativeBonusId18);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId19) && obj.cumulativeBonusId19 > 0) {
      res.push(obj.cumulativeBonusId19);

    }
    if (!Utils.isNullOrUndefined(obj.cumulativeBonusId20) && obj.cumulativeBonusId20 > 0) {
      res.push(obj.cumulativeBonusId20);

    }
     return res;
  }

  public addCumulativeBonus(obj:CumulativeBonusIdInterface,toAdd: CumulativeBonus) : boolean{

    if (Utils.isNullOrUndefined(obj.cumulativeBonusId1) || obj.cumulativeBonusId1<=0){
      obj.cumulativeBonusId1 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId2) || obj.cumulativeBonusId2<=0){
      obj.cumulativeBonusId2 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId3) || obj.cumulativeBonusId3<=0){
      obj.cumulativeBonusId3 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId4) || obj.cumulativeBonusId4<=0){
      obj.cumulativeBonusId4 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId5) || obj.cumulativeBonusId5<=0){
      obj.cumulativeBonusId5 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId6) || obj.cumulativeBonusId6<=0){
      obj.cumulativeBonusId6 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId7) || obj.cumulativeBonusId7<=0){
      obj.cumulativeBonusId7 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId8) || obj.cumulativeBonusId8<=0){
      obj.cumulativeBonusId8 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId9) || obj.cumulativeBonusId9<=0){
      obj.cumulativeBonusId9 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId10) || obj.cumulativeBonusId10<=0){
      obj.cumulativeBonusId10 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId11) || obj.cumulativeBonusId11<=0){
      obj.cumulativeBonusId11 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId12) || obj.cumulativeBonusId12<=0){
      obj.cumulativeBonusId12 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId13) || obj.cumulativeBonusId13<=0){
      obj.cumulativeBonusId13 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId14) || obj.cumulativeBonusId14<=0){
      obj.cumulativeBonusId14 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId15) || obj.cumulativeBonusId15<=0){
      obj.cumulativeBonusId15 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId16) || obj.cumulativeBonusId16<=0){
      obj.cumulativeBonusId16 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId17) || obj.cumulativeBonusId17<=0){
      obj.cumulativeBonusId17 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId18) || obj.cumulativeBonusId18<=0){
      obj.cumulativeBonusId18 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId19) || obj.cumulativeBonusId19<=0){
      obj.cumulativeBonusId19 = toAdd.id;
      return true;
    }else if (Utils.isNullOrUndefined(obj.cumulativeBonusId20) || obj.cumulativeBonusId20<=0){
      obj.cumulativeBonusId20 = toAdd.id;
      return true;
    }
    return false;
  }

  public hasCumulativeBonus(obj:CumulativeBonusIdInterface){
    if (obj.cumulativeBonusId1>0){
      return true;
    }
    if (obj.cumulativeBonusId2>0){
      return true;
    }
    if (obj.cumulativeBonusId3>0){
      return true;
    }
    if (obj.cumulativeBonusId4>0){
      return true;
    }
    if (obj.cumulativeBonusId5>0){
      return true;
    }
    if (obj.cumulativeBonusId6>0){
      return true;
    }
    if (obj.cumulativeBonusId7>0){
      return true;
    }
    if (obj.cumulativeBonusId8>0){
      return true;
    }
    if (obj.cumulativeBonusId9>0){
      return true;
    }
    if (obj.cumulativeBonusId10>0){
      return true;
    }
    if (obj.cumulativeBonusId11>0){
      return true;
    }
    if (obj.cumulativeBonusId12>0){
      return true;
    }
    if (obj.cumulativeBonusId13>0){
      return true;
    }
    if (obj.cumulativeBonusId14>0){
      return true;
    }
    if (obj.cumulativeBonusId15>0){
      return true;
    }
    if (obj.cumulativeBonusId16>0){
      return true;
    }
    if (obj.cumulativeBonusId17>0){
      return true;
    }
    if (obj.cumulativeBonusId18>0){
      return true;
    }
    if (obj.cumulativeBonusId19>0){
      return true;
    }
    if (obj.cumulativeBonusId20>0){
      return true;
    }
    return false;
  }


}
